import React from 'react';

export default function CredentialInstructions() {
  return (
    <>
      <strong>Instructions to get your credentials: </strong>
      <ul style={{ marginTop: '0.5rem', paddingLeft: '1rem', listStyle: 'disc' }}>
        <li>Log in to your Pictory account.</li>
        <li>
          If this is your first time logging in to Pictory, check your inbox for a password reset email to set your
          password.
        </li>
        <li>Click on your Initial at the top-right corner of the screen.</li>
        <li>
          Select <strong>API Subscription</strong>.
        </li>
        <li>Your API Key and Quota will be listed on that page.</li>
      </ul>
    </>
  );
}
